import { useTranslation } from 'next-i18next';
import { Button, Modal } from '@components/common';

interface ActivationConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  packageType: string;
  creditTier: string;
  subtitle: string;
  isLoading?: boolean;
}

/**
 * @description Confirmation modal for activating services (Sourcing/Screening)
 */
export const ActivationConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  packageType,
  creditTier,
  subtitle,
  isLoading = false,
}: ActivationConfirmModalProps) => {
  const { t } = useTranslation('common');

  return (
    <Modal
      size="xs"
      isOpen={isOpen}
      onClose={onClose}
      body={(
        <div className="m-4 flex flex-col gap-2">
          <h3 className="text-left font-bold">
            {t('offer.activating.confirm', {
              package_type: packageType,
              credit_tier: creditTier,
              defaultValue: `${packageType} ${creditTier}.`,
            })}
          </h3>
          <p className="text-left">{subtitle}</p>
          <div className="mt-4 flex justify-end gap-3">
            <Button
              styling="solid"
              color="white"
              rounding="full"
              size="sm"
              onClick={onClose}
              disabled={isLoading}
            >
              {t('global.action.cancel')}
            </Button>
            <Button
              styling="solid"
              color="secondary"
              rounding="full"
              size="sm"
              onClick={onConfirm}
              isLoading={isLoading}
            >
              {t('offer.subscription_section.label.activate')}
            </Button>
          </div>
        </div>
      )}
    />
  );
};
